module.exports = __webpack_public_path__ + "img/总览.9658a5ff.svg";